import { PROCESSING_TASK } from "./const.js";
export const _handleMouseDownOnSelectorRotateCircleEl = (self, event) => {
  const selection = self._getSelectionThrowable();
  const selection_rotate_transform =
    self._getSelectionRotateTransformThrowable();
  const { clientX: client_x, clientY: client_y } = event;
  const point = self._toViewPortPoint({
    x: client_x,
    y: client_y,
  });
  const origin_point = self._getSelectorCenterPointInViewPort();
  if (origin_point == null) {
    return;
  }
  const { x: origin_x, y: origin_y } = origin_point;
  selection_rotate_transform.start({
    x1: origin_x,
    y1: origin_y,
    x2: point.x,
    y2: point.y,
    origin_x,
    origin_y,
    els: [...selection.getSelectedEls()],
  });
  self._processing_task = PROCESSING_TASK.ROTATE_TRANSFORMING;
  self._rotate_transforming_origin_x = origin_x;
  self._rotate_transforming_origin_y = origin_y;
};
